import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-413" data-mp="11wl6kmzxbic0">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} onClick={e => {
      if (e.target === e.currentTarget) onClose();
    }} className="fixed inset-0 bg-black/90 backdrop-blur-md z-[3000] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" data-id="element-414" data-mp="1pngydk4dqdj9">
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} className="bg-night-2 rounded-3xl max-w-2xl w-full max-h-[85vh] flex flex-col border border-white/10" data-id="element-415" data-mp="3cftibssy34ih">
            <div className="flex items-center justify-between p-6 border-b border-white/10" data-id="element-416" data-mp="3vbtg5k8lt29z">
              <h2 className="font-display text-2xl text-white" data-id="element-417" data-mp="3qfcqumpo4hvb">Política de Privacidad</h2>
              <button onClick={onClose} aria-label="Cerrar" className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center text-white/70 transition-colors hover:bg-white/10 hover:text-white" data-id="element-418" data-mp="2104vd1foy5ho">
                <XIcon className="w-4 h-4" data-id="element-419" data-mp="2pphmcl39pogl" />
              </button>
            </div>
            
            <div className="p-6 sm:p-8 overflow-y-auto text-white/70 text-sm leading-relaxed space-y-6" data-id="element-420" data-mp="2uoub5bdp95lt">
              <section data-id="element-421" data-mp="2znnp14wweymi">
                <h3 className="text-white font-medium text-base mb-2" data-id="element-422" data-mp="2zoypaur4xo8v">1. Información General</h3>
                <p data-id="element-423" data-mp="34lywj8zq0x1k">
                  En Refugio Caracolí, valoramos y respetamos su privacidad. Esta política describe cómo recopilamos, 
                  utilizamos y protegemos su información personal cuando visita nuestro sitio web o utiliza nuestros servicios.
                </p>
              </section>
              
              <section data-id="element-424" data-mp="3idx1d7meg6rx">
                <h3 className="text-white font-medium text-base mb-2" data-id="element-425" data-mp="3ig9f18l4juz6">2. Recopilación de Datos</h3>
                <p data-id="element-426" data-mp="3nboozpg0h6qb">
                  Recopilamos información personal que usted nos proporciona voluntariamente al realizar una reserva, 
                  comunicarse con nosotros vía WhatsApp o suscribirse a nuestras comunicaciones. Esto puede incluir su 
                  nombre, número de teléfono, dirección de correo electrónico y preferencias de estadía.
                </p>
              </section>
              
              <section data-id="element-427" data-mp="11s8g5pr7qg8i">
                <h3 className="text-white font-medium text-base mb-2" data-id="element-428" data-mp="11t1q0zlgxluv">3. Uso de la Información</h3>
                <p data-id="element-429" data-mp="1zep9yl0qmbpi">
                  Utilizamos su información para:
                </p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-430" data-mp="1ugdzq96j5z6r">
                  <li data-id="element-431" data-mp="1uj098eczeorm">Procesar y gestionar sus reservas.</li>
                  <li data-id="element-432" data-mp="1pomhclxj2zrp">Comunicarnos con usted respecto a su estadía.</li>
                  <li data-id="element-433" data-mp="1krmeejvz6d4t">Mejorar nuestros servicios y personalizar su experiencia.</li>
                  <li data-id="element-434" data-mp="2i5ynd5dmpkmd">Enviar información relevante o promociones (solo si ha dado su consentimiento).</li>
                </ul>
              </section>
              
              <section data-id="element-435" data-mp="2ddf6nzjna9dc">
                <h3 className="text-white font-medium text-base mb-2" data-id="element-436" data-mp="1xxicfmwkv4ym">4. Protección de Datos</h3>
                <p data-id="element-437" data-mp="22wlgp54qh75j">
                  Implementamos medidas de seguridad razonables para proteger su información personal contra acceso, 
                  alteración, divulgación o destrucción no autorizada. No compartimos, vendemos ni alquilamos su 
                  información a terceros sin su consentimiento explícito, excepto cuando sea requerido por la ley.
                </p>
              </section>
              
              <section data-id="element-438" data-mp="2lnck7q21i3c0">
                <h3 className="text-white font-medium text-base mb-2" data-id="element-439" data-mp="2llrt6aexp2iw">5. Contacto</h3>
                <p data-id="element-440" data-mp="26x5e89t7ycs7">
                  Si tiene preguntas o inquietudes sobre nuestra política de privacidad o el manejo de sus datos, 
                  por favor contáctenos a través de refugiocaracoli@gmail.com o a nuestro número de WhatsApp.
                </p>
              </section>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}